(function ($, Drupal, once) {
  Drupal.behaviors.accordion = {
    attach: function attach(context) {
      $(once('expandable-block-container', '.expandable-block-container', context)).each(function () {
        const $expandableBlock = $(this);
        const hasItems = $expandableBlock.find('li.expandable-block-container');

        $expandableBlock
          .off()
          .on('click', '.expandable-block-title:visible', function (e) {
            e.preventDefault();
            const $expandableBlockTitle = $(this);
            const $container = $(this).closest('.expandable-block-container');
            if (hasItems.length > 0) {
              if ($container.hasClass('collapsed')) {
                $container.removeClass('collapsed').addClass('revealed');
                $expandableBlockTitle.trigger('expandable_revealed');
                $expandableBlockTitle
                  .next('.expandable-block-content')
                  .slideDown();
              } else {
                $container.removeClass('revealed').addClass('collapsed');
                $expandableBlockTitle.trigger('expandable_collapsed');
                $expandableBlockTitle
                  .next('.expandable-block-content')
                  .slideUp();
              }
            }
          });
      });
    },
  };
}(jQuery, Drupal, once));
